import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Accounts from './Accounts';
import AccountGroups from './AccountGroups';
import FeeMarkups from './FeeMarkups';
import FeeTypes from './FeeTypes';
import PaymentTerms from './PaymentTerms';
import Reconciles from './Reconciles';
import Reports from './Reports';

import Txns from './Txns';
import Txn from './Txns/show';
import TxnLines from './TxnLines';
import Expenses from './Expenses';
import Invoices from './Invoices';
import CreditMemos from './CreditMemos';
import CustomerRefunds from './CustomerRefunds';
import PaddleServicePayments from './PaddleServicePayments';
import Payments from './Payments';
import Payment from './Payments/show';

import VendorIssues from './Expenses/VendorIssues';

import Import from './Imports';
import AchBatches from './AchBatches';

const AccountingRoutes = () => {
  return (
    <Routes>
      <Route exact path="accounts" element={<Accounts />} />
      <Route exact path="account-groups" element={<AccountGroups />} />
      <Route exact path="ach-batches" element={<AchBatches />} />
      <Route exact path="fee-markups" element={<FeeMarkups />} />
      <Route exact path="fee-types" element={<FeeTypes />} />
      <Route exact path="payment-terms" element={<PaymentTerms />} />
      <Route exact path="reconciliation" element={<Reconciles />} />
      <Route exact path="reports" element={<Reports />} />

      <Route exact path="transactions" element={<Txns />} />
      <Route exact path="transactions/:id" element={<Txn />} />
      <Route exact path="register/:type/:id" element={<TxnLines />} />
      <Route exact path="expenses" element={<Expenses />} />
      <Route exact path="invoices" element={<Invoices />} />
      <Route exact path="credit-memos" element={<CreditMemos />} />
      <Route exact path="customer-refunds" element={<CustomerRefunds />} />
      <Route
        exact
        path="paddle-service-payments"
        element={<PaddleServicePayments />}
      />
      <Route exact path="payments" element={<Payments />} />
      <Route exact path="payments/:id" element={<Payment />} />

      <Route exact path="expenses/vendor-issues" element={<VendorIssues />} />

      <Route exact path="import" element={<Import />} />
    </Routes>
  );
};

export default AccountingRoutes;
